import Request from './Request';
import qs from 'qs';

export default class DataSet {
	constructor(json, contractor_id) {
		this.request_id = null;
		this.json = json;
		this.synced = false;
		this.contractor_id = contractor_id;
	}

	static createInstance(store) {
		let hash = store.getters.dataSet;
		store.commit('resetDataset');
		let contractor_id = store.getters.accessToken.iss;
		return new DataSet(JSON.stringify(hash), contractor_id);
	}

	reset() {
		this.synced = false;
	}

	sync() {
		this.synced = true;
		return this;
	}

	_createUpdateRequest(url, onDone, onFail, onToPromise) {
		let req =  new Request({
			method: 'post',
			url: url,
			headers: { 
				'content-type': 'application/x-www-form-urlencoded'},
			data: qs.stringify({
				contractor_id: this.contractor_id,
				dataset: this.json,
			}),
		}, onDone, onFail, onToPromise);
		this.request_id = req.request_id;
		return req;
	}

	createUpdateRequest(onDone, onFail, onToPromise) {
		return this._createUpdateRequest('/api/v1/dataset', onDone, onFail, onToPromise);
	}

	createUpdateMemberRequest(onDone, onFail, onToPromise) {
		return this._createUpdateRequest('/api/v1/dataset/member', onDone, onFail, onToPromise);
	}

	createUpdateProgressRateRequest(onDone, onFail, onToPromise) {
		return this._createUpdateRequest('/api/v1/dataset/progress_rate', onDone, onFail, onToPromise);
	}
	
	createUpdateTitleRequest(onDone, onFail, onToPromise) {
		return this._createUpdateRequest('/api/v1/dataset/title', onDone, onFail, onToPromise);
	}
	
	createUpdateColorRequest(onDone, onFail, onToPromise) {
		return this._createUpdateRequest('/api/v1/dataset/color', onDone, onFail, onToPromise);
	}
	
	createUpdateProjectPinnedRequest(onDone, onFail, onToPromise) {
		return this._createUpdateRequest('/api/v1/dataset/project_pinned', onDone, onFail, onToPromise);
	}
}
